<template>
  <!-- 表格点击视图，其中包括"客户/供应商视图、采购单视图、合同视图" -->
  <div>
    <!-- <customer-view
      ref="customerRef"
      :dialog-visible="customerVisible"
      @close="closeView"
    />
    <purchase-note-view
      ref="purchaseNoteRef"
      :dialog-visible="purchaseNoteVisible"
      @close="closeView"
    />
    <contract-order-view
      ref="contractOrderRef"
      :dialog-visible="contractOrderVisible"
      @close="closeView"
    />
    <project-manage-view
      ref="projectManageRef"
      :dialog-visible="projectManageVisible"
      @close="closeView"
    />-->
    <component
      v-if="flag"
      :is="getName"
      ref="componentRef"
      :loading="loading"
      :isShowEdit="isShowEdit"
      :dialog-visible="flag"
      @close="clickViewClose"
      @onClickView="onClickView"
    />
  </div>
</template>

<script>
// import customerView from '@/views/customerManage/detail.vue'
// import purchaseNoteView from '@/views/purchase/purchaseNote/detail.vue'
// import contractOrderView from '@/views/contractManage/contractOrder/detail.vue'
// import projectManageView from '@/views/projectManage/detail.vue'
export default {
  name: 'clickView',
  // components: {
  //   customerView,
  //   purchaseNoteView,
  //   contractOrderView,
  //   projectManageView
  // },
  data () {
    return {
      componentNames: '',
      flag: false,
      loading: false,
      viewName: '',
      rowData: '',
      dataId: '',
      isShowEdit: true
    }
  },
  computed: {
    getName () {
      if (this.componentNames) {
        return (resolve) => require([`@/views/${this.componentNames}`], resolve)
      }
      return null
    }
  },
  methods: {
    /**
     * @param {boolean} [isShowEdit=false] 是否显示编辑按钮 (库存结转记录进入)
     */
    openView (viewName, rowData, dataId, isShowEdit = true) {
      this.viewName = viewName
      this.rowData = JSON.parse(JSON.stringify(rowData))
      this.dataId = dataId
      console.log('clickView===>', viewName, rowData, dataId)
      this.loading = true
      switch (viewName) {
        case 'customer':
          this.componentNames = 'customerManage/detail.vue'
          this.isShowEdit = isShowEdit
          if (dataId) {
            this.$get('/customer/followCheck', { dataId: dataId }).then(res => {
              if (res.data.status === 1) {
                if (res.data.data) {
                  // this.customerVisible = true
                  this.flag = true
                  // setTimeout(() => {
                  //   this.loading = false
                  //   this.$refs.componentRef.initData(rowData, dataId)
                  // }, 500)
                } else {
                  this.$message.warning('暂无权限访问该数据!')
                }
              } else {
                this.$message.warning(res.data.message)
              }
            })
          } else {
            this.$get('/customer/followCheck', { dataId: rowData.customerId }).then(res => {
              if (res.data.status === 1) {
                if (res.data.data) {
                  // this.customerVisible = true
                  this.flag = true
                  // setTimeout(() => {
                  //   this.loading = false
                  //   this.$refs.componentRef.initData(rowData, dataId)
                  // }, 500)
                } else {
                  this.$message.warning('暂无权限访问该数据!')
                }
              } else {
                this.$message.warning(res.data.message)
              }
            })
          }
          break
        case 'purchase':
          this.componentNames = 'purchase/purchaseNote/detail.vue'
          this.isShowEdit = isShowEdit
          this.$get('/purchase/followCheck', { dataId: dataId }).then(res => {
            if (res.data.status === 1) {
              if (res.data.data) {
                this.flag = true
                // setTimeout(() => {
                //   this.$refs.componentRef.initData(rowData, dataId)
                // }, 500)
              } else {
                this.$message.warning('暂无权限访问该数据!')
              }
            } else {
              this.$message.warning(res.data.message)
            }
          })
          break
        case 'contract':
          this.componentNames = 'contractManage/contractOrder/detail.vue'
          this.isShowEdit = isShowEdit
          this.$get('/contract/followCheck', { dataId: dataId }).then(res => {
            if (res.data.status === 1) {
              if (res.data.data) {
                this.flag = true
                // this.contractOrderVisible = true
                // setTimeout(() => {
                //   this.$refs.componentRef.initData(rowData, dataId)
                // }, 500)
              } else {
                this.$message.warning('暂无权限访问该数据!')
              }
            } else {
              this.$message.warning(res.data.message)
            }
          })
          break
        case 'project':
          this.isShowEdit = isShowEdit
          this.componentNames = 'projectManage/detail.vue'
          this.$get('/project/followCheck', { dataId: dataId }).then(res => {
            if (res.data.status === 1) {
              if (res.data.data) {
                this.flag = true
                // this.projectManageVisible = true
                // setTimeout(() => {
                //   this.$refs.componentRef.initData(rowData, dataId)
                // }, 500)
              } else {
                this.$message.warning('暂无权限访问该数据!')
              }
            } else {
              this.$message.warning(res.data.message)
            }
          })
          break
        case 'salesOpportunities':
          this.isShowEdit = isShowEdit
          this.componentNames = 'salesOpportunities/projectOpportunities/details.vue'
          this.$get('/saleOpportunity/followCheck', { dataId: dataId }).then(res => {
            if (res.data.status === 1) {
              if (res.data.data) {
                this.flag = true
              } else {
                this.$message.warning('暂无权限访问该数据!')
              }
            } else {
              this.$message.warning(res.data.message)
            }
          })
          break
      }
    },
    onClickView () {
      this.$refs.componentRef.initData(this.rowData, this.dataId)
    },
    clickViewClose () {
      this.$emit('close')
      this.flag = false
    }
  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/view/clickView.vue